import { ChangeDetectorRef, Component, DestroyRef, ElementRef, inject, Input, OnInit, ViewChild } from '@angular/core';
import { PeerToPeerManageService } from 'app/manage-p2p/services/peer-to-peer-manage/peer-to-peer-manage.service';
import { ModalP2pAddFundrasingService } from 'app/manage-p2p/services/modal-p2p-add-fundrasing/modal-p2p-add-fundrasing.service';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { loadP2PCampaignList, peerToPeerReport } from 'app/manage-p2p/features/p2p.actions';
import { ToastService } from 'app/toast/services/toast.service';
import { ChampionsImportService } from 'app/import-champions/services/champions-import.service';
import { DonorService } from 'app/core/services/donor.service';
import { CoreModule } from 'app/core/core.module';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { MdbAutocompleteModule } from 'mdb-angular-ui-kit/autocomplete';
import { CommonModule } from '@angular/common';
import { NgxCurrencyDirective } from 'ngx-currency';
import { GoogleMapsAutocompleteModule } from 'app/google-maps-autocomplete/google-maps-autocomplete.module';
import { ModalStreetAddressService } from 'app/manage-p2p/services/modal-street-address/modal-street-address.service';
import { SharedService } from 'app/virtual-event/services/shared.service';
import { MdbInputGoogleMapsAutocompleteComponent } from 'app/core/components/mdb-input-google-maps-autocomplete/mdb-input-google-maps-autocomplete.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EmailNameSpliterService } from 'app/core/services/email-name-spliter.service';

@Component({
  standalone:true,
  selector: 'app-p2p-add-fundrasing-modal',
  templateUrl: './p2p-add-fundrasing-modal.component.html',
  styleUrl: './p2p-add-fundrasing-modal.component.scss',
  imports:[CoreModule,FormsModule,ReactiveFormsModule,MdbSelectModule,MdbAutocompleteModule,GoogleMapsAutocompleteModule,CommonModule, NgxCurrencyDirective, MdbInputGoogleMapsAutocompleteComponent]
})
export class P2pAddFundrasingModalComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  @Input () data: any = null;
  
  @ViewChild('p2pAddressField', {static: true}) field: ElementRef;

  public fundrasingForm: UntypedFormGroup;
  public isModalOpen = false;

  public campaignData: any = null;
  public campaignTypeData: any = null;
  public loadCampaignList: boolean = false;

  public userData: any = null;
  public userId: any = null;

  public searchResult = [];
  private allProfiles = null;
  public notFound = false;

  public searchedUserData = null;
  public searchedName ='';
  public searchedEmail = '';

  public isNameInputLabelActive: boolean = false;
  public isEmailInputLabelActive: boolean = false;
  public isDisplayNameInputLabelActive:boolean = false;

  public isAddActive = false;
  public showTeams = false;

  public name: any = null;
  public email: any = null;
  public goal: any = null;
  public teamId: any = null;
  public addressInput: any = null;
  public addressUnit: any = null;
  public phone: any = null;
  public addInfo: any = null;
  public addInfoSelect: any = null;
  public displayName: any = null;
  public sendNotification: any = null;

  public address: string = null;
  public isUnitLabelActive: boolean = false;

  constructor(
    public peerToPeerManageService: PeerToPeerManageService,
    public modalP2pAddFundrasingService: ModalP2pAddFundrasingService,
    private formBuilder: UntypedFormBuilder,
    private store: Store,
    private toastService: ToastService,
    private championsImportService: ChampionsImportService,
    private donorService: DonorService,
    private cdr: ChangeDetectorRef,
    private modalStreetAddressService: ModalStreetAddressService,
    private sharedService: SharedService,
    private emailNameSpliter: EmailNameSpliterService,
  ) {}

  ngOnInit() {
    this.campaignData = this.data.campaign;
    this.campaignTypeData = this.data.campaign.campaignTypeData;
    this.loadCampaignList = this.data.loadCampaignList || false;
    this.showTeams = this.campaignTypeData.teamEnabled && this.campaignTypeData.teams.length > 0;
    
    const formControls = {
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.pattern(/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/)]],
      goal: ['', Validators.required],
      teamId: [''],
      addressInput: [''],
      addressUnit: [''],
      phone: [''],
      addInfo: [''],
      addInfoSelect: [''],
      displayName:['',Validators.required],
      sendNotification: [false]
    };
    this.fundrasingForm = this.formBuilder.group(formControls);

    this.name = this.fundrasingForm.get('name')
    this.email = this.fundrasingForm.get('email')
    this.goal = this.fundrasingForm.get('goal')
    this.teamId =  this.fundrasingForm.get('teamId')
    this.addressInput = this.fundrasingForm.get('addressInput')
    this.addressUnit = this.fundrasingForm.get('addressUnit')
    this.phone = this.fundrasingForm.get('phone')
    this.addInfo = this.fundrasingForm.get('addInfo')
    this.addInfoSelect = this.fundrasingForm.get('addInfoSelect')
    this.displayName = this.fundrasingForm.get('displayName')
    this.sendNotification = this.fundrasingForm.get('sendNotification')

    const {streetAddressRequired, addressOptional, phoneNumRequired, phoneOptional, 
      additionalInfoDesc, additionalInfoSelectDesc } = this.campaignData;

    if (this.showTeams) {
      this.teamId.setValidators([Validators.required]);
    }
    if(streetAddressRequired && !addressOptional) {
      this.addressInput.setValidators([Validators.required]);
    }
    if(phoneNumRequired && !phoneOptional) {
      this.phone.setValidators([Validators.required]);
    }
    if(additionalInfoDesc) {
      this.addInfo.setValidators([Validators.required]);
    }
    if(additionalInfoSelectDesc) {
      this.addInfoSelect.setValidators([Validators.required]);
    }
  }

  addFundrasing() {
    if(this.fundrasingForm.status === 'INVALID') {
      this.fundrasingForm.markAllAsTouched();
      return false
    }

    if(this.goal.value < 1) {
      this.fundrasingForm.get('goal').setErrors({'incorrect': true})
      return false;
    }

    let numberStr = this.phone.value
    let digitCount = (numberStr.match(/\d/g) || []).length;
  
    if(numberStr !== '' && digitCount < 11){
      this.fundrasingForm.get('phone').setErrors({'incorrect': true})
      return false;
    }

    const { campaign: { id: campaignId }} = this.data;
    const { additionalInfoDesc, additionalInfoSelectDesc } = this.campaignData;

    let fundraiser = {
      name: this.name.value,
      email: this.email.value,
      goal: this.goal.value,
      displayName: this.displayName.value
    }

    if(this.showTeams) {
      fundraiser['teamId'] = this.teamId.value;
    }
    if(this.campaignData.streetAddressRequired) {
      fundraiser['streetAddress'] = this.addressInput.value || {};
    }
    if(this.campaignData.phoneNumRequired) {
      fundraiser['phone'] = this.phone.value;
    }
    if(additionalInfoDesc) {
      fundraiser['additionalInfo'] = this.addInfo.value;
    }
    if(additionalInfoSelectDesc) {
      fundraiser['additionalInfoSelected'] = this.fundrasingForm.get('addInfoSelect').value;
    }

    this.championsImportService.addFundraiserList(campaignId, [fundraiser], this.sendNotification.value).pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((response: any) => {
      this.store.dispatch({
        type: peerToPeerReport.type,
        payload: campaignId
      });

      let toastType = 'success';
      let toastMessage = 'Created Successfully';

      if(response.failedCount > 0) {
        toastType = 'danger';
        toastMessage = 'Error Creating Champion';
      }
      this.toastService.show(toastType, toastMessage, {delay: 1500});

      this.close();
      if(this.loadCampaignList) {
        this.store.dispatch({
          type: loadP2PCampaignList.type,
          payload: this.sharedService.token
        });
      }
    })
  }

  passOption(event: MouseEvent | KeyboardEvent){
    let searchString;
    if (event instanceof MouseEvent) {
      searchString = (event.target as HTMLElement).innerText;
    } else if (event instanceof KeyboardEvent && event.target instanceof HTMLInputElement) {
      searchString = event.target.value;
    }

    const [name, email] = this.emailNameSpliter.getNameAndEmail(searchString, true);

    this.name.setValue('');
    this.email.setValue('');

    this.isNameInputLabelActive = false;
    this.isEmailInputLabelActive = false;

    this.name.setValue(name);
    this.email.setValue(email);

    this.isNameInputLabelActive = !!this.name.value;
    this.isEmailInputLabelActive = !!this.email.value;

    this.searchedUserData = this.userData.filter((item)=>
      item.name.toLowerCase().includes(name.toLowerCase()) &&
      item.email.toLowerCase().includes(email.toLowerCase())
    );

    this.userId = this.searchedUserData[0].id;
    this.searchedName = this.searchedUserData[0].name;
    this.searchedEmail = this.searchedUserData[0].email;
  }

  searchDonor(value, name) {
    if(value.length > 1) {
      this.donorService.search(value, name)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((userProfiles) => {
          this.allProfiles = userProfiles;
          this.search(value)
      });
    }
  }

  search(searchValue) {
    let profileInfo = this.allProfiles.usersProfile.map(data => ({
      "data": data,
      "searchString": data.name + "/" + data.email
    }));

    let searchString = profileInfo.map(item => item.searchString);
    this.userData = profileInfo.map(item => item.data);

    let filteredResult = profileInfo.filter((item)=>item.searchString.toLowerCase().includes(searchValue))

    if(filteredResult.length === 0)
      this.notFound = true
    else
      this.notFound = false;
      
    this.searchResult = filteredResult;
  }

  onAutocompleteSelected({ address_components, formatted_address }) {
    const { street1, street2, city, zip, state, country } = window['utils'].parseGoogleStreetAddress(address_components)
    const address = this.addressInput;
    const unitNum = this.addressUnit.value;
    address.setValue({
      street1,
      street2,
      city,
      zip,
      state,
      country,
      unitNum: unitNum
    });

    const addressText = window['utils'].getStreetAddressText(address.value);
    this.address = addressText;
  }

  onLocationSelected($event) {
  }

  onClearAddress() {
    this.address = '';
    const address = this.addressInput;
    address.setValue('');
  }

  onBlur() {
    const address = this.addressInput;
    const addressText = window['utils'].getStreetAddressText(address.value);
    this.address = addressText;

    if (this.field) {
      this.field.nativeElement.value = addressText;
    }
  }

  openStreetAddressModal() {
    this.isModalOpen = true;

    const modalRef = this.modalStreetAddressService.open(this.campaignData, true);
    
    modalRef.onClose.pipe().subscribe((selectedAddress) =>{
      if(selectedAddress != 'close') {
        const addressText = window['utils'].getStreetAddressText(selectedAddress);
      
        this.addressInput.setValue(selectedAddress);
        this.address = addressText;

        if(selectedAddress?.unitNum) {
          this.addressUnit.setValue(selectedAddress.unitNum);
          this.isUnitLabelActive = true;
        }
      }
      this.modalStreetAddressService.modalRef = null;
      this.isModalOpen = false;
    })
  }

  close() {
    this.modalP2pAddFundrasingService.close();
  }

  onClickField(field) {
    switch(field.dataset.name) {
      case 'name':
        this.isNameInputLabelActive = true;
        break;
      case 'email':
        this.isEmailInputLabelActive = true;
        break;
      case 'displayName':
        this.isDisplayNameInputLabelActive = true;
        break;
    }
    field.focus();
    this.cdr.markForCheck();
  }
}
